var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightRedIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right-arrow-7288805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "right arrow",
    d: "M21.69 11.7108C21.6521 11.6216 21.5978 11.5402 21.53 11.4708L18.53 8.47082C18.3878 8.33834 18.1998 8.26622 18.0055 8.26965C17.8112 8.27308 17.6258 8.35179 17.4884 8.4892C17.351 8.62662 17.2723 8.812 17.2688 9.0063C17.2654 9.2006 17.3375 9.38865 17.47 9.53082L19.19 11.2508H3C2.80109 11.2508 2.61032 11.3298 2.46967 11.4705C2.32902 11.6111 2.25 11.8019 2.25 12.0008C2.25 12.1997 2.32902 12.3905 2.46967 12.5312C2.61032 12.6718 2.80109 12.7508 3 12.7508H19.19L17.47 14.4708C17.3295 14.6114 17.2507 14.8021 17.2507 15.0008C17.2507 15.1996 17.3295 15.3902 17.47 15.5308C17.6106 15.6713 17.8012 15.7502 18 15.7502C18.1988 15.7502 18.3894 15.6713 18.53 15.5308L21.53 12.5308C21.5978 12.4615 21.6521 12.3801 21.69 12.2908C21.7296 12.1993 21.7501 12.1006 21.7501 12.0008C21.7501 11.9011 21.7296 11.8024 21.69 11.7108Z",
    fill: "#A71F23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightRedIcon1);
export default __webpack_public_path__ + "static/media/right-red-icon (1).253355d45a3b11c608e986e9b96ffac6.svg";
export { ForwardRef as ReactComponent };